import HelperUrl from '../utilities/helperUrl.js';
import DOMPurify from 'dompurify';
(function($) {
    $.widget('ca.caMembershipWizard', {
        _create: function() {
            this.hidePreloader();
            var self = this;

            this.element.find('.nav li > a').on('click', function(e){
                e.preventDefault();
                e.stopPropagation();

                var selected_step = $(this).parent('li').index() + 1;
                var current_step = self.getCurrentStep();

                if (selected_step < current_step) {
                    self.goBack(selected_step);
                }
            });

            function changeState(state) {
                switch (state.data.path) {
                    case '/membership-application/wizard/2':
                        self.initStep2(state.data.html);
                        break;
                    case '/membership-application/wizard/3':
                        self.initStep3(state.data.html);
                        break;
                    default:
                        self.initStep1();
                }
            }

            var state = History.getState();
            var urlStep = +state.url.match(/membership-application\/wizard\/?(\d?)/)[1] || 1;
            var stepTab = this.element.find('#mw-step' + urlStep);
            if (!stepTab.length) {
                stepTab = this.element.find('#mw-step1');
                urlStep = 1;
            }

            this.initStep1();

            if (urlStep > 1) {
                if (state.data.path) {
                    changeState(state);
                } else {
                    this.loadStep(
                        urlStep,
                        null,
                        this.getActiveTab().find('>form')
                    ).done(function(json) {
                        var data = JSON.parse(json);
                        if (data.errors || data.message) {
                            History.replaceState(
                                {
                                    path: '/membership-application/wizard/1',
                                    html: ''
                                },
                                'A little about yourself and your interests',
                                '/membership-application/wizard/1'
                            );
                        }
                    });
                }
            }

            History.Adapter.bind(
                window,
                'statechange',
                function() {
                    var state = History.getState();
                    if (state.data.step) {
                        self.element.find('div.step:gt(' + (state.data.step - 1) + ')').removeClass('initialized');
                    }
                    changeState(state);
                }
            );
        },

        goBack: function(selected_step) {
            this.element.find('div.step:gt(' + (selected_step - 1) + ')').removeClass('initialized');
            var current_step = this.getCurrentStep();
            var nextStep = selected_step - current_step;
            var nextIndex = History.getCurrentIndex() + nextStep;
            var state = History.getStateByIndex(nextIndex);
            if (state.step != selected_step) {
                var data = location.search.substr(1);
                this.loadStep(
                    selected_step,
                    data,
                    this.getActiveTab().find('>form')
                );
            }
        },

        showPreloader: function() {
            $('.ma-preloader').show();
        },

        hidePreloader: function() {
            $('.ma-preloader').hide();
        },

        setActiveTab: function(n) {
            var $li = this.element.find('.nav li');
            $li.removeClass('active');
            $($li.get(n - 1)).addClass('active');
        },

        getActiveTab: function() {
            return $('#mw-step' + this.getCurrentStep());
        },

        getCurrentStep: function() {
            return this.element.find('.nav li.active').index() + 1;
        },

        equalizeHeight: function($elements, padding) {
            var h = 0;
            $elements.each(function(){
                var th = +$(this).height() + padding;

                if (th > h) {
                    h = th;
                }
            });
            $elements.height(h);
        },

        // Bootstrap Carousel is not used here.
        // We use jQuery Slick Carousel below
        setupCarousel: function () {
            var self = this;
            var $slider = $('.ca-pro-ui #mw-step3 .membership-carousel');

            if ($slider.find('.carousel-item').length == 1) {
                $slider.addClass('row');
                $slider.width(270).css('margin', '0 auto');
            } else if ($slider.find('.carousel-item').length == 2) {
                $slider.addClass('row');
                $slider.width(540).css('margin', '0 auto');
                $slider.find('.carousel-item').addClass('col-sm-6');

                var $active = $slider.find('.carousel-item');
                self.equalizeHeight($active.find('.mw-badge-description'), 0);
                self.equalizeHeight($active.find('thead th'), 0);
            } else {
                $slider.on(
                    'setPosition',
                    function () {
                        var $active = $slider.find('.slick-slide');
                        self.equalizeHeight($active.find('.mw-badge-description'), 0);
                        self.equalizeHeight($active.find('thead th'), 0);
                    }
                );

                $slider.slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
                    nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
                    responsive: [
                        {
                            breakpoint: 1100,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 750,
                            settings: 'unslick'
                        }
                    ]
                });

                return $slider;
            }
        },

        canUseCustomSelect: function() {
            if (window.navigator.appName === "Microsoft Internet Explorer") {
                return document.documentMode >= 8;
            }
            if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
                return false;
            }
            if (/Android/i.test(window.navigator.userAgent)) {
                if (/Mobile/i.test(window.navigator.userAgent)) {
                    return false;
                }
            }
            return true;
        },

        loadStep: function(step, data, $form) {
            switch (step) {
                case 1:
                    return this.loadStep1();
                case 2:
                    return this.loadStep2(data, $form);
                case 3:
                    return this.loadStep3(data, $form);
            }
        },

        loadStep1: function()
        {
            window.History.pushState(
                {
                    path: '/membership-application/wizard/1',
                    html: '',
                    step: 1
                },
                'A little about yourself and your interests',
                '/membership-application/wizard/1'
            );
        },

        initStep1: function() {
            var self = this;
            var $step = this.element.find('#mw-step1');
            var $form = $step.find('>form');

            this.setActiveTab(1);
            this.element.find('>.step').hide();
            $step.show();

            if ($step.hasClass('initialized')) {
                return;
            }

            // Initialize Chosen
            if (this.canUseCustomSelect()) {
                $form.find('.mw-select').removeClass('mw-select');
            } else {
                self.setupSelectForMobile($form.find('#mw_membership_for'));
            }

            var selects = $form.find('.select-chosen');
            selects.chosen({
                width: '100%',
                disable_search_threshold: 10
            });

            this.element.each(function() {
                this.addEventListener('touchstart', function(event) {
                    if (!$(event.target).parents('.chosen-container').length) {
                        selects.trigger('chosen:close');
                    }
                }, { passive: true });
            });

            $('#mw_membership_for', $form).on('change', function() {
                var value = $(this).val();
                if (value !== '') {
                    if (!self.canUseCustomSelect()) {
                        $('#mw_membership_for', $form).css("color", "#394263");
                    }
                    const homeClubId = document.getElementById('home_club_id').value;

                    const url = new URL('/membership-application/wizard-populate-form', window.location.origin);
                    url.searchParams.append('membership_for', value);
                    url.searchParams.append('home_club_id', homeClubId);

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            const sanitizedHtml = DOMPurify.sanitize(data.html, {
                                ALLOWED_TAGS: ['form', 'input', 'div', 'label', 'select', 'option', 'button', 'i'],
                                ALLOWED_ATTR: ['type', 'name', 'value', 'id', 'class', 'data-placeholder', 'multiple', 'selected', 'placeholder']
                            });

                            const parser = new DOMParser();
                            const doc = parser.parseFromString(sanitizedHtml, 'text/html');
                            const newForm = doc.querySelector('form');

                            const step1Form = document.querySelector('#mw-step1 form');
                            step1Form.parentNode.replaceChild(newForm, step1Form);

                            $step.removeClass('initialized');
                            self.initStep1();
                        })
                        .catch(error => console.error('Error fetching data:', error));
                }
            });

            $form.on('submit', function(e){
                e.preventDefault();
                e.stopPropagation();
                self.loadStep2($form.serialize(), $form);
            });

            var promoCodeField = $form.find('#mw_promo_code');
            promoCodeField.on('change', function() {
                var $field = $(this);
                if (this.value == '') {
                    $field.closest('.form-group').removeClass('has-error');
                    $field.next().filter('.help-block.animation-slideDown').remove();
                    return;
                }
                $.getJSON("/membership-application/check-promo-code", {
                    code: this.value
                }).done(function(data){
                    if (data.errors == 0) {
                        $field.closest('.form-group').removeClass('has-error');
                        $field.next().filter('.help-block.animation-slideDown').remove();
                    } else {
                        $field.next('.help-block.animation-slideDown').remove();
                        $field.after( $('<div class="help-block animation-slideDown">' + DOMPurify.sanitize(data.msg) + '</div>'));
                        $field.closest('.form-group').addClass('has-error');
                    }
                });
            });
            if (!promoCodeField.val() == '') {
                promoCodeField.trigger('change');
            }

            $step.addClass('initialized', true);
        },

        loadStep2: function(formData, $form) {
            var self = this;
            self.showPreloader();

            return $.ajax({
                type: "POST",
                url: "/membership-application/wizard",
                dataType: 'html',
                data: {
                    step: 2,
                    form_data: formData
                }
            }).done(function(json) {
                $form.find('div.messages').remove();
                $form.find('.form-group').removeClass('has-error');

                var data = JSON.parse(json);
                if (data.errors || data.message) {
                    if (data.errors) {
                        $.each(data.errors, function (field, message) {
                            var $field = $form.find('[name=' + field + ']');
                            $field.closest('.form-group').addClass('has-error');
                        });
                    }

                    if (data.message) {
                        const text = document.createTextNode(data.message);
                        const div = document.createElement('div');
                        div.className = 'messages';
                        div.appendChild(text);
                        $form.prepend(div);
                      }

                    return;
                }

                if (data.html) {
                    window.History.pushState(
                        {
                            path: '/membership-application/wizard/2',
                            html: data.html,
                            step: 2
                        },
                        'Select your Home Club',
                        '/membership-application/wizard/2?' + formData
                    );
                }
            }).always(function(){
                self.hidePreloader();
            });
        },

        setupSelectForMobile: function($select) {
            const $options = $('option', $select);
            if ($options.length < 2) {
                return;
            }
            const firstOption = $options[0];
            var placeholder = $select.data("placeholder");
            $(firstOption).attr("label", placeholder);
            $(firstOption).attr("disabled", true);

            if ($('option[selected]', $select).length == 0) {
                $select.css("color", "#999");
            }
        },

        initStep2: function(data) {
            var self = this;
            var $step = this.element.find('#mw-step2');

            this.setActiveTab(2);
            this.element.find('>.step').hide();
            $step.show();

            if ($step.hasClass('initialized')) {
                return;
            }

            $step.empty();
            $step.html(data);
            var $form = $step.find('>form');

            // Initialize Chosen
            if (this.canUseCustomSelect()) {
                $step.find('.mw-select').removeClass('mw-select');
            } else {
                self.setupSelectForMobile($form.find('#mw_home_club'));
            }

            $step.find('.select-chosen').chosen({
                width: '100%',
                disable_search_threshold: 10
            });

            var currentClub = null;
            var clubsAddress = $form.find('.club-address');

            $form.find('#mw_home_club').on('change', function() {
                if (this.value > 0) {
                    clubsAddress.hide();
                    var address = $form.find('.club-address.club-id-' + this.value);
                    address.show();

                }

                if (!self.canUseCustomSelect()) {
                    $('#mw_home_club', $form).css("color", "#394263");
                }
            });

            if ($form.find('#mw_home_club').hasClass("hidden")) {
                $form.find('#mw_home_club').closest(".mw-select").addClass("hidden");
            }

            if (clubsAddress.filter('div[class*="club-id"]').length == 1) {
                currentClub = clubsAddress.filter('div[class*="club-id"]');
                currentClub.show();
            } else {
                var homeClub = $form.find('#mw_home_club').val();
                if (homeClub) {
                    currentClub = clubsAddress.filter('.club-address.club-id-' + homeClub)
                    currentClub.show();
                } else {
                    clubsAddress.first().show();
                    currentClub = clubsAddress.filter('div[class*="club-id"]');
                }
            }

            $form.on('reset', function(e){
                e.preventDefault();
                e.stopPropagation();
                $step.removeClass('initialized');
                self.goBack(self.getCurrentStep() - 1);
            });

            $form.on('submit', function(e){
                e.preventDefault();
                e.stopPropagation();
                var $homeClub = $form.find('#mw_home_club');
                var home_club_id = +$homeClub.val();

                if (home_club_id > 0) {
                    $('#home_club_id').val(home_club_id);
                    $homeClub.removeAttr('disabled');
                    self.loadStep3(home_club_id, $form);
                } else {
                    $homeClub.closest('.form-group').addClass('has-error');
                    return false;
                }
            });

            $step.addClass('initialized', true);
        },

        selectEntity: function(entityId) {
            var select = this.element.find('#mw_home_club');
            select.val(entityId);
            select.trigger('change');
            select.trigger('chosen:updated');
        },

        loadStep3: function(home_club_id, $form) {
            var self = this;
            self.showPreloader();

            var urlParamsParsed = HelperUrl.parseUrlParams(location.search);

            if (home_club_id) {
                urlParamsParsed['?home_club_id'] = home_club_id;
            }

            var urlParams = decodeURIComponent(jQuery.param(urlParamsParsed)).substr(1);

            return $.ajax({
                type: "POST",
                url: "/membership-application/wizard",
                dataType: 'html',
                data: {
                    step: 3,
                    form_data: urlParams
                }
            }).done(function(json) {
                var data = JSON.parse(json);
                $form.find('div.messages').remove();
                if (data.message) {
                    const text = document.createTextNode(data.message);
                    const div = document.createElement('div');
                    div.className = 'messages';
                    div.appendChild(text);
                    $form.prepend(div);
                  }
                if (data.html) {
                    window.History.pushState(
                        {
                            path: '/membership-application/wizard/3',
                            html: data.html,
                            step: 3
                        },
                        'Membership Option',
                        '/membership-application/wizard/3?' + urlParams
                    );
                }
            }).always(function() {
                self.hidePreloader();
            });
        },

        initStep3: function(data) {
            var self = this;
            var $step = this.element.find('#mw-step3');

            this.setActiveTab(3);
            this.element.find('>.step').hide();
            $step.show();

            if ($step.hasClass('initialized')) {
                return;
            }

            $step.empty();
            $step.html(data);

            this.setupCarousel();

            $step.find('.mw-signup').on('click', function(){
                var membership_id = $(this).data('id');
                $step.find('input[name=MembershipID]').val(membership_id);
            });

            $step.addClass('initialized', true);
        }
    });
})(jQuery);
